import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import AdminTitle from 'components/molecules/home/AdminTitle';
import SideBarContainer from 'containers/SideBarContainer';
import AdminHomeContainer from 'containers/home/AdminHomeContainer';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import PageView from 'hoc/PageView';
import ProtectedRoute from 'hoc/ProtectedRoute';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const AdminIndexPage = () => (
    <AdminTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<AdminTitle />}>
        <AdminHomeContainer />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Admin' }),
    PageView({ page: 'Viewed Admin Home Page' }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(AdminIndexPage);



// WEBPACK FOOTER //
// ./src/components/pages/home/AdminIndex.js